import React from 'react';
import { Row, Col, Card } from "reactstrap";
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import AutoAwesomeRoundedIcon from '@material-ui/icons/StarRounded';
import Typography from '@material-ui/core/Typography'
import MotComponent from './MotComponent';
import "../HomeSections.css";

// "Tax Days Remaining: -34" is not something a person can read at a glance.
const describeDays = days => {
  const value = parseInt(days, 10);
  if (isNaN(value)) return null;
  if (value < 0) return `Expired ${Math.abs(value)} days ago`;
  if (value === 0) return "Expires today";
  return `${value} days remaining`;
};

// A paid check the free report cannot answer. Reads as "not unlocked yet"
// rather than "we have no idea".
const LockedRow = ({ label }) => (
  <div className="report-div">
    <Row className="rc-check-row rc-check-row--locked">
      <Col className="key-data">
        <Typography variant="body1">{label}</Typography>
      </Col>
      <Col className="value-data">
        <Typography variant="body1">
          <LockRoundedIcon style={{ fontSize: 18, marginRight: 4 }} />
          Full check only
        </Typography>
      </Col>
    </Row>
  </div>
);

const VehicleReport = ({ currentResult, isImportedGood, isFinancedGood, isStolenGood,
                         isScrappedGood, isWrittenOffGood, isMOTGood, motMetaData, isTaxedGood,
                         vedMetaData, onGetReport }) => {
  if (currentResult) {
    let vehImage = 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-1u-05-09-24-11-26-29-exam-revision.jpg';
    const {
      FreeVehicleImages: {  ImageDetailsList },
      FreeGeneralInfo: {
         Vrm, Make, YearOfManufacture, Colour, Model, Co2Emissions, EngineSize, FuelType, RegistrationDate,
        OutstandingRecalls, DateOfLastV5cIssue
      },
      MotHistory: { RecordCount, RecordList },
      VehicleStatus: { MotVed }
    } = currentResult;

    const { VedCurrentlyValid, VedExpiryDate, VedDaysRemaining, MotSornInPlace } = MotVed;
    vehImage = ImageDetailsList[0]["ImageUrl"];

    // if (ImageDetailsCount > 0) {
    //   // Parse the ExpiryDate string directly into a Date object
    //   let expiryDate = new Date(ImageDetailsList[0]["ExpiryDate"]);
    //
    //   // Get today's date without the time for accurate comparison
    //   let today = new Date();
    //   today.setHours(0, 0, 0, 0); // Reset to midnight to compare dates only
    //
    //   // Check that expiryDate is not in the past
    //   if (expiryDate > today) {
    //     vehImage = ImageDetailsList[0]["ImageUrl"];
    //   }
    // }

    // const formattedDateRegistered = formatDate(DateFirstRegistered);
    //
    // const furtherDetailArr = [
    //   { 'title': 'First Registered', 'value': formattedDateRegistered },
    //   { 'title': 'Number of Previous Keepers', 'value': NumberOfPreviousKeepers === 0 ? 1 : NumberOfPreviousKeepers },
    //   { 'title': 'V5 Certificates', 'value': V5CCertificateCount },
    //   { 'title': 'Vehicle Class', 'value': VehicleClass },
    //   { 'title': 'Vin Last 5', 'value': VinLast5 },
    //   { 'title': 'Door Plan', 'value': DoorPlan },
    //   { 'title': 'CO2 Emission', 'value': `${Co2Emissions} g/km` },
    //   { 'title': 'EuroStatus', 'value': EuroStatus },
    //   { 'title': 'Driven Axle', 'value': DrivingAxle },
    //   { 'title': 'Kerb Weight', 'value': KerbWeight },
    //   { 'title': 'Seating Capacity', 'value': SeatingCapacity },
    //   { 'title': 'Number Of Doors', 'value': NumberOfDoors },
    // ];
    // Co2Emissions, EngineSize, FuelType, RegistrationDate,
    //         OutstandingRecalls, DateOfLastV5cIssue
    const genVehInfoArr = [
      { 'title': 'Make', 'value': Make },
      { 'title': 'Model', 'value': Model },
      { 'title': 'Colour', 'value': Colour },
      { 'title': 'Engine Size', 'value': EngineSize },
      { 'title': 'Registration Date', 'value': RegistrationDate },
      { 'title': 'Outstanding Recalls', 'value': OutstandingRecalls },
      { 'title': 'Date of Last V5C Issue', 'value': DateOfLastV5cIssue },
    ];

    return (
      <div id="divToPrint">
        {/* Identity strip: everything needed to confirm this is the right car */}
        <div className="rc-report-head">
          <div className="rc-report-id">
            <span className="report-plate">{Vrm}</span>
            <h2>{Make} {Model}</h2>
            <p>{YearOfManufacture} &middot; {Colour} &middot; {FuelType} &middot; {EngineSize}</p>
          </div>
          <img className="rc-report-img" src={vehImage} alt="" aria-hidden="true" />
        </div>

        {/* Free AI insights. Deliberately routed through the report chooser so
            the email is still captured; the link itself is emailed out. */}
        <button type="button" onClick={onGetReport} className="rc-ai-promo">
          <AutoAwesomeRoundedIcon className="rc-ai-promo-icon" />
          <div className="rc-ai-promo-copy">
            <strong>Free AI insights for this car</strong>
            <span>
              We read the full MOT record and explain what the advisories and
              failures actually mean. Free, sent to your email.
            </span>
          </div>
          <span className="rc-ai-promo-go">Get them free</span>
        </button>

        {/* At a glance */}
        <div className="rc-status-grid">
          <div className={isTaxedGood ? "rc-status rc-status--good" : "rc-status rc-status--bad"}>
            <div className="rc-status-top">
              <span className="rc-status-label">Tax</span>
              {isTaxedGood
                ? <CheckCircleRoundedIcon style={{ fill: "#1a9b57" }} />
                : <CancelRoundedIcon style={{ fill: "#d15353" }} />}
            </div>
            <div className="rc-status-value">
              {isTaxedGood ? "Taxed" : "Not taxed"}
            </div>
            <div className="rc-status-meta">
              {VedExpiryDate && <div>Valid until {VedExpiryDate}</div>}
              {describeDays(VedDaysRemaining) && <div>{describeDays(VedDaysRemaining)}</div>}
              {MotSornInPlace && <div>SORN declared</div>}
            </div>
          </div>

          <div className={isMOTGood ? "rc-status rc-status--good" : "rc-status rc-status--bad"}>
            <div className="rc-status-top">
              <span className="rc-status-label">MOT</span>
              {isMOTGood
                ? <CheckCircleRoundedIcon style={{ fill: "#1a9b57" }} />
                : <CancelRoundedIcon style={{ fill: "#d15353" }} />}
            </div>
            <div className="rc-status-value">
              {isMOTGood ? "Valid MOT" : "No valid MOT"}
            </div>
            <div className="rc-status-meta">
              {motMetaData && Object.entries(motMetaData).map(([key, value]) => (
                value !== null && value !== undefined && (
                  <div key={key}>
                    {key === "Days Until Next Due"
                      ? describeDays(value)
                      : `${key}: ${value}`}
                  </div>
                )
              ))}
            </div>
          </div>
        </div>
        <Row style={{ fontWeight: 800, paddingBottom: "64px" }}>
          {/*Checklist*/}
          <Col xs={12} sm={6}>
            <div>
              <Typography variant="h6" className="rc-report-heading" gutterBottom>
                Checklist
              </Typography>

              {/*Taxed*/}
              <div className="report-div">
                <Row className={isTaxedGood ? "rc-check-row rc-check-row--good" : "rc-check-row rc-check-row--bad"}>
                  <Col className="key-data">
                    <Typography variant="body1">
                      Tax
                    </Typography>
                  </Col>
                  <Col className="value-data">
                    <Typography variant="body1">
                      {isTaxedGood ? <CheckRoundedIcon /> : <ClearRoundedIcon />} {isTaxedGood ? "Yes" : "No"}
                    </Typography>
                    {Object.entries(vedMetaData).map(([key, value]) => (
                      value !== null && (
                        <div className="report-meta" key={key}>
                          <strong>{key}:</strong> {value}
                        </div>
                      )
                    ))}
                  </Col>
                </Row>
              </div>

              {/*Imported*/}
              <div className="report-div">
                <Row className={isImportedGood ? "rc-check-row rc-check-row--good" : "rc-check-row rc-check-row--warn"}>
                  <Col className="key-data">
                    <Typography variant="body1">
                      Imported
                    </Typography>
                  </Col>
                  <Col className="value-data">
                    <Typography variant="body1">
                      {isImportedGood ? <CheckRoundedIcon /> : <ClearRoundedIcon />} {isImportedGood ? "No" : "Yes"}
                    </Typography>
                  </Col>
                </Row>
              </div>

              {/*Financed*/}
              <LockedRow label="Finance outstanding" />

              {/*Stolen*/}
              <LockedRow label="Stolen" />

              {/*Scrapped*/}
              <LockedRow label="Scrapped" />

              {/*Written Off*/}
              <LockedRow label="Written off" />

              {/*MOT*/}
              <div className="report-div">
                <Row className={isMOTGood ? "rc-check-row rc-check-row--good" : "rc-check-row rc-check-row--bad"}>
                  <Col className="key-data">
                    <Typography variant="body1">
                      MOT
                    </Typography>
                  </Col>
                  <Col className="value-data">
                    {isMOTGood ? <CheckRoundedIcon /> : <ClearRoundedIcon />} {isMOTGood ? "Yes" : "No"}
                    {Object.entries(motMetaData).map(([key, value]) => (
                      <div className="report-meta" key={key}>
                        <strong>{key}:</strong> {value}
                      </div>
                    ))}
                  </Col>
                </Row>
              </div>
            </div>

            {/*General Vehicle Info*/}
            <div className="general-veh-sect">
              <Typography variant="h6" className="rc-report-heading" gutterBottom>
                General Vehicle Info
              </Typography>
              <div className="report-meta">
                <Typography variant="subtitle2" gutterBottom>
                  You should carefully check each value below to make sure that it corresponds to the vehicle
                </Typography>
              </div>
              {genVehInfoArr.map((obj, idx) => (
                obj.value !== null && (
                  <div key={idx}>
                    <Row>
                      <Col className="key-data">
                        <Typography variant="body1" gutterBottom>
                          {obj.title}
                        </Typography>
                      </Col>
                      <Col className="value-data">
                        <Typography variant="body1" gutterBottom>
                          {obj.value}
                        </Typography>
                      </Col>
                    </Row>
                    <hr className="hr-data" />
                  </div>
                )
              ))}
            </div>
          </Col>

          {/*MOT History*/}
          <Col xs={12} sm={6}>
            <div>
              <Typography variant="h6" className="rc-report-heading" gutterBottom>
                MOT History
              </Typography>
            </div>
            <Row>
              <Col>
                <Typography variant="body1">
                  MOT Count
                </Typography>
              </Col>
              <Col>
                <Typography variant="body1">
                  {RecordCount}
                </Typography>
              </Col>
            </Row>
            <Row>
              {RecordList && RecordList.map((d, i) => (
                <div key={i} className="mot-component-container">
                  <MotComponent d={d} i={i} />
                </div>
              ))}
            </Row>
          </Col>
        </Row>

        <Row>
          {/*General Vehicle Info*/}
          {/*<Col xs={12} sm={6}>*/}
          {/*  <Typography variant="h6" className="rc-report-heading" gutterBottom>*/}
          {/*    General Vehicle Info*/}
          {/*  </Typography>*/}
          {/*  <div className="report-meta">*/}
          {/*    <Typography variant="subtitle2" gutterBottom>*/}
          {/*      You should carefully check each value below to make sure that is corresponds to the vehicle*/}
          {/*    </Typography>*/}
          {/*  </div>*/}
          {/*  {genVehInfoArr.map((obj, idx) => (*/}
          {/*    obj.value !== null && (*/}
          {/*      <div key={idx}>*/}
          {/*        <Row>*/}
          {/*          <Col className="key-data">*/}
          {/*            <Typography variant="body1" gutterBottom>*/}
          {/*              {obj.title}*/}
          {/*            </Typography>*/}
          {/*          </Col>*/}
          {/*          <Col className="value-data">*/}
          {/*            <Typography variant="body1" gutterBottom>*/}
          {/*              {obj.value}*/}
          {/*            </Typography>*/}
          {/*          </Col>*/}
          {/*        </Row>*/}
          {/*        <hr className="hr-data" />*/}
          {/*      </div>*/}
          {/*    )*/}
          {/*  ))}*/}
          {/*</Col>*/}

          {/*/!*Further Vehicle Checks*!/*/}
          {/*<Col xs={12} sm={6}>*/}
          {/*  <div>*/}
          {/*    <Typography variant="h6" className="rc-report-heading" gutterBottom>*/}
          {/*      Further Vehicle Checks*/}
          {/*    </Typography>*/}
          {/*  </div>*/}
          {/*  {furtherDetailArr.map((obj, index) => (*/}
          {/*    obj.value !== null && (*/}
          {/*      <div key={index}>*/}
          {/*        <Row>*/}
          {/*          <Col className="key-data">*/}
          {/*            <Typography variant="body1" gutterBottom>*/}
          {/*              {obj.title}*/}
          {/*            </Typography>*/}
          {/*          </Col>*/}
          {/*          <Col className="value-data">*/}
          {/*            <Typography variant="body1" gutterBottom>*/}
          {/*              {obj.value}*/}
          {/*            </Typography>*/}
          {/*          </Col>*/}
          {/*        </Row>*/}
          {/*        <hr className="hr-data" />*/}
          {/*      </div>*/}
          {/*    )*/}
          {/*  ))}*/}
          {/*  <Row>*/}
          {/*    <Col className="key-data">*/}
          {/*      <Typography variant="body1" gutterBottom>*/}
          {/*        No of Plate Change(s)*/}
          {/*      </Typography>*/}
          {/*    </Col>*/}
          {/*    <Col className="value-data">*/}
          {/*      <Typography variant="body1" gutterBottom>*/}
          {/*        {PlateChangeCount}*/}
          {/*      </Typography>*/}
          {/*      <div>*/}
          {/*        {PlateChangeList && PlateChangeList.map((change, idx) => (*/}
          {/*          <div key={idx}>*/}
          {/*            <Typography variant="body1" gutterBottom>*/}
          {/*              From: <span className="report-plate"> {change.PreviousVRM} </span> &nbsp;To: <span className="report-plate"> {change.CurrentVRM} </span>*/}
          {/*            </Typography>*/}
          {/*          </div>*/}
          {/*        ))}*/}
          {/*      </div>*/}
          {/*    </Col>*/}
          {/*  </Row>*/}
          {/*</Col>*/}
        </Row>
      </div>
    );
  } else {
    return (
      <div className="col-12 col-md-12 col-lg-12 mt-12">
        <Card>No record Found</Card>
      </div>
    );
  }
};

export default VehicleReport;
